import { Capacitor } from '@capacitor/core';
import { Box, NavList } from '@deckee/deck-hand';
import React, { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTheme } from 'styled-components';
import captureSpecificError from '../../../../services/capture-error';
import { openShareDialog } from '../../../../services/store/modules/sharing';
import {
  checkSocialSharingPluginExists,
  getURLFromPath,
  nativeShareAction,
} from '../../../helpers/share-helpers';
import SheetLayout, {
  SheetBody,
} from '../../../layouts/SheetLayout/SheetLayout';
import {
  externalLink,
  link,
  ReactSvg,
  send,
} from '../../../shared/vector-images';

const ShareMenuPage: FC = () => {
  const theme = useTheme();
  const location = useLocation();
  const dispatch = useDispatch();
  const [textCopied, setTextCopied] = useState(false);

  const { sharePath, shareText, description, title, type, id } =
    location.state as {
      sharePath: string;
      shareText: string;
      title: string;
      description: string;
      type: string;
      id: string;
    };

  const copyTextToClipboard = async () => {
    try {
      // Apparently there was a bug in the navigator.clipboard
      // fallback to input field copy which only works with readonly on the input field
      const el = document.createElement('textarea');
      el.value = getURLFromPath(sharePath);
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      setTextCopied(true);
    } catch (error) {
      captureSpecificError(
        error,
        'containers/app-main-client/src/components/features/Sharing/ShareMenuPage/ShareMenuPage.tsx',
      );
    }
  };

  const handleShareViaDeckee = () => {
    dispatch(
      openShareDialog(sharePath, shareText, title, description, type, id),
    );
  };

  const handleNativeShare = () => {
    // Note sure why we need this plugin, but it was using it previously
    if (checkSocialSharingPluginExists()) {
      nativeShareAction(sharePath, title);
    } else {
      navigator.share({
        url: getURLFromPath(sharePath),
        text: description,
        title: shareText,
      });
    }
  };

  return (
    <SheetLayout showMenuBar={false} heading="Share">
      <SheetBody>
        <NavList>
          <NavList.Item onClick={copyTextToClipboard}>
            <ReactSvg
              toDisplay={link()}
              options={{
                fillColor: theme.colors.primary,
              }}
              width={24}
              height={24}
            />

            <Box>Copy Link</Box>
            {textCopied && (
              <Box
                fontSize={1}
                fontWeight="500"
                flex="1 1 0px"
                textAlign="right"
                color="success"
              >
                Copied!
              </Box>
            )}
          </NavList.Item>
          {Capacitor.isPluginAvailable('Share') &&
            Capacitor.isNativePlatform() && (
              <NavList.Item onClick={handleNativeShare}>
                <ReactSvg
                  //   className={cx('submit-share__icon')}
                  toDisplay={externalLink()}
                  options={{
                    fillColor: theme.colors.primary,
                  }}
                  width={24}
                  height={24}
                />
                <Box>Share via...</Box>
              </NavList.Item>
            )}
          <NavList.Item onClick={handleShareViaDeckee}>
            <ReactSvg
              //   className={cx('submit-share__icon')}
              toDisplay={send()}
              options={{
                fillColor: theme.colors.primary,
              }}
              width={24}
              height={24}
            />
            <Box>Send via Deckee</Box>
          </NavList.Item>
        </NavList>
      </SheetBody>
    </SheetLayout>
  );
};

export default ShareMenuPage;
